import '../../resources/css/visual/ModalProjectDetail.scss';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { openModal, closeModal, popupModalConfirm, openModalAlert } from '../../actions/index';
import { doDeleteFloorPlanData } from '../../actions/visual/index';
import { checkTableAuth } from '../common/access-auth';
import ProjectForm from './ProjectForm';



// import moment from 'moment';
// import { closeMapModal, forwardMapList } from '../../actions/visual/index';
// import IpsAttackMapList from './IpsAttackMapList';


class ModalProjectDetail extends Component {
    constructor(props) {
        super(props);

        // this.backMapList = this.backMapList.bind(this);
        // this.closeModal = this.closeModal.bind(this);
        // this.updateShow = this.updateShow.bind(this);

        this.state = {
            show: false
        }
    }



    handleDelete(){
        const { popupModalConfirm, authToken, accountRole, roleTableAuth, openModalAlert, floorPlan, doDeleteFloorPlanData, closeModal } = this.props;
        
        if (checkTableAuth('rf_map', accountRole, roleTableAuth, 2)) {
            popupModalConfirm('Delete', 'icon-ico-failed', 'Confirm to delete?', 300, () => {doDeleteFloorPlanData(floorPlan.seq, authToken)}, null, false);
            closeModal(null);
        } else {
            openModalAlert("Sorry, you don't have permission to change config.");
        }
    }

    componentDidMount() {
    }
      
    componentDidUpdate (prevProps, prevState, snapshot) {  
    }

    render() {
        const { modalStatus, modalMessage, closeModal, openModal, accountRole, roleTableAuth } = this.props;
        let show = modalStatus === 'FloorPlan', renderContent;
        if (show) {
            renderContent = (
                <Modal
                    show={show}
                    dialogClassName='project-detail'
                    centered
                    onHide={() => closeModal(null)}
                >
                    <Modal.Body>
                        {/* <Row>
                            <Col sm={12} > */}
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6} className='area-modal-title'>
                                <span className='icon-rf-map-white'></span><label>{modalMessage === 'edit' ? 'Edit Project' : modalMessage === 'add' ? 'Add project' : 'Project Info'}</label>
                                    {/* <div className={ modalType === 'list' ? 'area-label' : 'area-label no-display'}>
                                        <label>From : { displayFrom }</label>
                                    </div>
                                    <div className={ modalType === 'detail' ? 'area-back-icon' : 'area-back-icon no-display'}>
                                        <span className='icon-back-detail' onClick={this.backMapList}></span>
                                    </div> */}
                                </Col>
                                <Col sm={6} className='area-close-btn'>
                                {modalMessage === 'view' ? <><span id="modal-project-detail-edit" className='icon-btn-edit-white-n' onClick={!checkTableAuth('rf_map', accountRole, roleTableAuth, 2) ? () => openModalAlert("This account role is not allowed to edit.") : () => { openModal("FloorPlan", 'edit', null, null)}}></span>
                                    <span id="modal-project-detail-delete" className='icon-btn-delete-white-n' onClick={() => this.handleDelete() }></span>
                                        </> : ''}
                                    <span id="modal-project-detail-close" className='area-icon-close-detail' onClick={() => closeModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-detail-content'>
                            <ProjectForm></ProjectForm>
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        } 
        else {
            renderContent = (<div className='modal-detail-empty'></div>);
        }

        return (
            <div className='modal-visual-manager-detail'>
                {renderContent}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    // const mapModal = state.visualReducers.mapModal;

    return {
        modalStatus: state.commonReducers.modalStatus,
        modalMessage: state.commonReducers.modalMessage,
        authToken: state.loginReducers.authToken,
        selectSite: state.siteReducers.selectSite,
        status: state.visualReducers.status,
        floorPlan: state.visualReducers.floorPlan,
        accountRole: state.loginReducers.accountRole,
        roleTableAuth: state.loginReducers.roleTableAuth,
    }
}

export default connect(
    mapStateToProps,
    { openModal, closeModal, popupModalConfirm, doDeleteFloorPlanData, openModalAlert }
)(ModalProjectDetail)